import axios from 'axios'

export const activateCoupon = async (token, couponId) => {
  const url = process.env.GATSBY_API_LOYALTY_APP

  const headers = {
    Authorization: `Bearer ${token}`,
    withCredentials: false,
    'x-functions-key': process.env.GATSBY_AZURE_FUNCTION_KEY,
    'Access-Control-Allow-Origin': '*'
  }
  const params = { op: 'activateCoupon', id: couponId }

  try {
    const res = await axios({
      method: 'post',
      headers,
      url,
      params
    })
    return res.status
  } catch (error) {
    console.error('Error while trying to activate Coupon: ', error.message)
    throw new Error('Coupon could not be activated.')
  }
}
